<div class="tag" [class]="type()">
  <ng-content></ng-content>
</div>
